module.exports = __webpack_public_path__ + "img/reward-2.88c61636.svg";